import { render } from "./PictureListView.vue?vue&type=template&id=4747b665&scoped=true"
import script from "./PictureListView.vue?vue&type=script&lang=js"
export * from "./PictureListView.vue?vue&type=script&lang=js"

import "./PictureListView.vue?vue&type=style&index=0&id=4747b665&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4747b665"

export default script